import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  AppBar,
  Toolbar,
  TextField,
  Button,
  Paper,
  CircularProgress,
  Container,
  CssBaseline,
  Snackbar,
  SnackbarContent,
  IconButton,
  Input,
  InputLabel,
  FormControl,
  FormHelperText,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Select,
  MenuItem,
  Avatar,
  Grid,
  CardContent,
  useMediaQuery,
  CardActionArea,
  InputAdornment
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import {
  Error,
  Close,
  Email,
  Help,
  WebAsset,
  Timeline,
  Equalizer,
  DirectionsBus,
  Block,
  AccountCircle,
} from "@material-ui/icons";

import { useHistory } from "react-router-dom";
import MaskedInput from "react-text-mask";
import { useSnackbar } from "notistack";

import icon from "../../assets/img/logo_primary.svg";
import CardShowcase from "../../assets/svg/success_top.svg";
import TopFailed from "../../assets/svg/failed_top.svg";
import LoadingPaymentStatus from "../../assets/svg/loading_payment_status.svg";

import Footer from "./footer.jsx";

import { withLocalize, Translate } from "react-localize-redux";
import { FinanceService } from "../../utils/web_config_2";
import axiosRetry from "axios-retry";
import { set } from "date-fns";
const axios = require("axios");
axiosRetry(axios, { retries: 3 });

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
  paper: {
    padding: 15,
  },
  btn: {
    textTransform: "capitalize",
  },
  card: {
    borderRadius: 15,
    // background:"#F7C62E"
  },
}));

function MaskedCard(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/
      ]}
      placeholderChar={"\u2000"}
      showMask={false}
      keepCharPositions={true}
    />
  );
}

function MaskedCode(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[/\d/, " ", /\d/, " ", /\d/, " ", /\d/, " ", /\d/, " ", /\d/]}
      placeholderChar={"\u2000"}
      showMask={false}
      keepCharPositions={true}
    />
  );
}

function Redirection(props) {
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));


 

  useEffect(() => {

    var token=props.match.params.token;
    get_details_payment(token);
    
  }, []);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [loadDetails,setLoadDetails]=useState(true);

  const [details,setDetails]=useState({});
  
  const get_details_payment=(token)=>{
    setLoadDetails(true);
    const detailsInstance = axios.create(new FinanceService().setHeadersMicroservice(new FinanceService().TOP_UP_TOKEN));
    detailsInstance.get(new FinanceService().CHECK_PAYMENT_STATUS+token)
    .then(res=>{
      var data=res.data.data;
      setDetails(data);
      
      if(data.status=="PENDING"){
        // continue checking if the status is pending...
        const retryCheckPaymentStatus = setTimeout(get_details_payment(token), 3000);
        
      }else{
        setLoadDetails(false);
      }
    })
    .catch(err=>{
      setLoadDetails(false);
    });
  }

  return (
    <div className={classes.root}>
      <CssBaseline />
     

      <AppBar position="static" color="transparent" elevation={0}>
        <Toolbar>
          <Box mr={2}>
            <img
              src={icon}
              style={{ height: 45 }}
              className={classes.icon}
              alt="Icon"
              onClick={() => history.push("/")}
            />
          </Box>
          <Typography variant="h5" className={classes.title}>
            Card Top-up
          </Typography>
          <IconButton>
            <Help />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Container maxWidth="sm">
        <Box pt={10}>
          {loadDetails==false?<Box p={2} display="flex" flexDirection="column">
           

            {details.status=="PAID"&&<img
              src={CardShowcase}
              style={{ height: 200 }}
              alt="Cards showcase"
            />}

            {details.status=="FAILED"&&<img
              src={TopFailed}
              style={{ height: 200 }}
              alt="Cards showcase"
            />}

            {details.status=="PENDING"&&<img
              src={LoadingPaymentStatus}
              style={{ height: 200 }}
              alt="Cards showcase"
            />}

            {details.status=="PAID"&&(
             <Typography color="textSecondary" variant="h5" align="center">
             Your card <b>{details.	
consumer_reference} </b>has been credited <b>{details.amount} {details.currency}</b>,Thank you for using Safaris Bus Card
           </Typography>)}
           
           {details.status=="FAILED"&&(<Typography color="textSecondary" variant="h5" align="center">
            Unforturnately your payment failed please try again!
           </Typography>)}

           {details.status=="PENDING"&&(<Typography color="textSecondary" variant="h5" align="center">
            Transaction still pending... Wait a moment
           </Typography>)}
           
            <Box
              mb={1}
              pt={8}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >


            </Box>
            
          </Box>:<Box p={2} display="flex" flexDirection="column">
           
            <Box
              mb={1}
              pt={4}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >

<CircularProgress color="primary"/>
            </Box>
            
          </Box>}
         

          
        </Box>
      </Container>
      <Container maxWidth="lg">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          mt={12}
          alignContent="center"
          width={1}
        >
          <div className={classes.ln2} />
          <Typography variant="h5" gutterBottom>
            <b>Top-Up Card</b>
          </Typography>
          <div className={classes.ln} />
        </Box>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          mb={10}
          alignContent="center"
          width={1}
        >
          <Box width={!fullScreen ? 1 / 2 : 1}>
            <Typography align="center">
              Top-up card is a way of booking your SafariBus card
              online and get it at one of our branches without waiting in
              queues.
            </Typography>
          </Box>
        </Box>

        <Grid container justify="center" alignContent="center">
          <Grid item xs={12} sm={4} md={3}>
            <CardContent>
              <Box display="flex" justifyContent="center" width={1} mb={2}>
                <Avatar className={classes.green}>
                  <Timeline fontSize="large" />
                </Avatar>
              </Box>

              <Typography
                gutterBottom
                variant="h5"
                component="h2"
                align="center"
                color="primary"
              >
                No queues
              </Typography>
              <Typography color="textSecondary" component="p" align="center">
                Don't waste your time queuing on our branches for your card, do
                your registration before and you will come only to pick it after
                showing your ID number.
              </Typography>
            </CardContent>
          </Grid>

          <Grid item xs={12} sm={4} md={3}>
            <CardContent>
              <Box display="flex" justifyContent="center" width={1} mb={2}>
                <Avatar className={classes.green}>
                  <Equalizer fontSize="large" />
                </Avatar>
              </Box>
              <Typography
                gutterBottom
                variant="h5"
                component="h2"
                align="center"
                color="primary"
              >
                No queues
              </Typography>
              <Typography color="textSecondary" component="p" align="center">
                Don't waste your time queuing on our branches for your card, do
                your registration before and you will come only to pick it after
                showing your ID number.
              </Typography>
            </CardContent>
          </Grid>

          <Grid item xs={12} sm={4} md={3}>
            <CardContent>
              <Box display="flex" justifyContent="center" width={1} mb={2}>
                <Avatar className={classes.green}>
                  <DirectionsBus fontSize="large" />
                </Avatar>
              </Box>
              <Typography
                gutterBottom
                variant="h5"
                component="h2"
                align="center"
                color="primary"
              >
                No queues
              </Typography>
              <Typography color="textSecondary" component="p" align="center">
                Don't waste your time queuing on our branches for your card, do
                your registration before and you will come only to pick it after
                showing your ID number.
              </Typography>
            </CardContent>
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </div>
  );
}

export default withLocalize(Redirection);
